import React from 'react';
import ScaledImg from '../ScaledImg';
import header from "./img/header.png"

interface ProductDescriptionSectionProps {
  shortTitle: string;
  setShortTitle: (value: string) => void;
  shortDescription: string;
  setShortDescription: (value: string) => void;
  entrustment: string;
  setEntrustment: (value: string) => void;
  paragraphs: string;
  setParagraphs: (value: string) => void;
}

const ProductDescriptionSection: React.FC<ProductDescriptionSectionProps> = ({
  shortTitle,
  setShortTitle,
  shortDescription,
  setShortDescription,
  entrustment,
  setEntrustment,
  paragraphs,
  setParagraphs
}) => {
  return (
    <div>
      <h2>Product Description</h2>

      Headers for the new (left) and current (right) webshop
      <ScaledImg src={header}/>

      <label htmlFor="shortTitle">Short title (3-5 words) *</label>
      <input
        type="text"
        id="shortTitle"
        value={shortTitle}
        onChange={(e) => setShortTitle(e.target.value)}
        required
      />

      <label htmlFor="shortDescription">Short description (50 - 100 characters) *</label>
      <input
        type="text"
        id="shortDescription"
        value={shortDescription}
        onChange={(e) => setShortDescription(e.target.value)}
        required
      />

      <label htmlFor="entrustment">Entrustment (150 - 200 characters) *</label>
      <input
        type="text"
        id="entrustment"
        value={entrustment}
        onChange={(e) => setEntrustment(e.target.value)}
        required
      />

      <label htmlFor="paragraphs">Product description - paragraphs (200 - 300 characters per line) *</label>
      <textarea
        id="paragraphs"
        value={paragraphs}
        onChange={(e) => setParagraphs(e.target.value)}
        required
      />
    </div>
  );
};

export default ProductDescriptionSection;
